import { Dispatch, SetStateAction } from 'react';
import { createCtx } from '@shared/util/context';

// favorites are an ordered list of channel ids, persisted in localstorage

export type FavoriteChannels = number[];

export interface FavoriteChannelsContextValue {
  favorites: FavoriteChannels;
  setFavorites: Dispatch<SetStateAction<FavoriteChannels>>;
  addFavorite: (channelId: number) => void;
  removeFavorite: (channelId: number) => void;
  toggleFavorite: (channelId: number) => void;
}

const [useFavoriteChannels, FavoriteChannelsContextProvider] =
  createCtx<FavoriteChannelsContextValue>();

export { useFavoriteChannels, FavoriteChannelsContextProvider };
